import { SalesManagerShopItemCategory, SalesManagerShopItemCategoryArray } from "@impacgroup/ayyildiz-checklist-platform-api-dtos";
import { CategoryType, CategoryTypeArray } from "../api-models/ShopItem";

function lowerwounderscore(str: string): string {
    return str.toLowerCase().replace(/_/g, "");
}

export function getSalesManagerItemCategoryI18N(category: SalesManagerShopItemCategory): string {
    const norm_id = lowerwounderscore(category);
    return `salesmanagershopitems.data.category.${norm_id}`;
}

export function getShopItemCategoryI18N(category: CategoryType): string {
    const norm_id = lowerwounderscore(category);
    return `shopitems.data.category.${norm_id}`;
}

export function getItemCategoryI18N(category: SalesManagerShopItemCategory | CategoryType): string {
    if (SalesManagerShopItemCategoryArray.includes(category as SalesManagerShopItemCategory)) {
        return getSalesManagerItemCategoryI18N(category);
    }
    if (CategoryTypeArray.includes(category as CategoryType)) {
        return getShopItemCategoryI18N(category as CategoryType);
    }
    return "";
}
